import InvalidDrillHoleGenerator from "./DrillHoleGenerators/Invalid";
import Trapezoid from "./DrillHoleGenerators/Trapezoid";
import Shape from "./DrillHoleGenerators/Shape";
import Invalid from "./DrillHoleGenerators/Invalid";
import RoundedRectangle from "./DrillHoleGenerators/RoundedRectangle";

export default class ShapeDrillHoleGeneratorFactory {
	getShapeDrillHoleGenerator( shape, parentModel ): Shape|Invalid {
		switch( shape ) {
			case "rectangle":
			case "isosceles-triangle":
			case "right-angled-triangle":
			case "right-angled-triangle-mirrored":
			case "sloped-rectangle":
			case "sloped-rectangle-flip-horizontal":
			case "sloped-right-rectangle":
			case "sloped-right-rectangle-flip-vertical":
				return new Shape( parentModel );
			case "trapezoid":
				return new Trapezoid( parentModel );
			case "rounded-rectangle":
				return new RoundedRectangle( parentModel );
			default:
				return new InvalidDrillHoleGenerator( parentModel );
		}
	}
}
